import { render, staticRenderFns } from "./frequency.vue?vue&type=template&id=e0d2176c"
import script from "./frequency.vue?vue&type=script&lang=js"
export * from "./frequency.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports